<template>
<div>
  <div class="row" v-if="labelPosition === 'left'">
    <div class="col-md-4">
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
    </div>
    <div class="col-md-8">
      <WorkflowButtons   
        :data='rowData' 
        :firstStep='firstStep'
        :workflow='workflow'
        :gridId="gridId"
      />
    </div>
  </div>
  <div v-else>
    <label
      class="form-control-label"
      :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
    >{{control.label}}</label>
    <WorkflowButtons   
      :data='rowData' 
      :firstStep='firstStep'
      :workflow='workflow'
      :gridId="gridId"
    />
  </div>
</div>
</template>

<script>
import WorkflowButtons from '@/components/WorkflowButtons'
import { mapState } from "vuex";

export default {
  name: "WorkflowControl",
  components: { 
    WorkflowButtons 
  },
  props: ["control", "labelPosition", 'rowData', 'gridId'],
  computed: {
    ...mapState(['dataGrid_options']),
    firstStep(){
      return this.dataGrid_options[this.gridId].meta[this.control.propName].startTitle
    },
    workflow(){
      return this.dataGrid_options[this.gridId].meta[this.control.propName].workflow
    }
  }
  // this.dataGrid_options[this.gridId].meta
};
</script>

